import { render, staticRenderFns } from "./PrintShipments.vue?vue&type=template&id=1d6d530a&scoped=true&"
import script from "./PrintShipments.vue?vue&type=script&lang=js&"
export * from "./PrintShipments.vue?vue&type=script&lang=js&"
import style0 from "./PrintShipments.vue?vue&type=style&index=0&id=1d6d530a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6d530a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
